import { Injectable } from '@angular/core';
import { LocalstorageConstant } from '../../constants/localstorage-constant';

export interface Preference {
  token?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() { }

  public save(preference: Preference) {
    if (preference.token) {
      localStorage.setItem(LocalstorageConstant.TOKEN, JSON.stringify(preference.token));
    }
  }

  public getItem(item: string): any {
    return JSON.parse(localStorage.getItem(item));
  }

  public removeItem(item: string) {
    localStorage.removeItem(item);
  }

  public destroy() {
    localStorage.clear();
  }
}
